import { render, staticRenderFns } from "./OsmOutrosDeptListagem.vue?vue&type=template&id=12885c7a&scoped=true&lang=pug&"
import script from "./OsmOutrosDeptListagem.vue?vue&type=script&lang=js&"
export * from "./OsmOutrosDeptListagem.vue?vue&type=script&lang=js&"
import style0 from "./OsmOutrosDeptListagem.vue?vue&type=style&index=0&id=12885c7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12885c7a",
  null
  
)

export default component.exports